module.exports = __webpack_public_path__ + "static/frontline-social-e23e6fac06d0a2372fc00e4acb47b9d9.jpg";